import AdminApplication from './AdminApplication';

export default AdminApplication;
